/**
 * Window event that focuses the trip map on one day.
 * Kept in its own module so the page can dispatch it without loading Leaflet.
 *
 * detail.day: day number (1-based), or null for all days
 */
export const TRIP_MAP_FOCUS_DAY_EVENT = 'trip-map:focus-day';

export interface TripMapFocusDayDetail {
  day: number | null;
}
